AdvancedSelectFragment:
  remoteHelp: Indica la ruta hasta la lista de opciones, el valor y la etiqueta.
  remoteHelpMore: Tutorial.
  remoteHelpText: |
    <b>EJEMPLO SIMPLE</b>

    La fuente externa devuelve datos en formato JSON, por ejemplo:
    <pre>
    {
        "books": [
            {
                "author": "Herman Melville",
                "category": "fiction",
                "isbn": "0-553-21311-3",
                "price": 8.99,
                "title": "Moby Dick"
            },
            {
                "author": "J. R. R. Tolkien",
                "category": "fiction",
                "isbn": "0-395-19395-8",
                "price": 22.99,
                "title": "The Lord of the Rings"
            }
        ]
    }
    </pre>
    La lista de opciones siempre está en una matriz, delimitada por corchetes <code>[]</code>. Cada opción está delimitada por llaves <code>{}</code>.
    <b>Ruta a las opciones</b>: en este ejemplo, la lista de opciones está en una clave llamada <code>books</code>. La ruta a las opciones es, por lo tanto, <code>books</code>. Es posible que la matriz de opciones esté directamente en la "raíz" de los resultados, en cuyo caso no necesitaremos especificar una ruta.
    <b>Ruta hasta la etiqueta</b>: en cada opción de la lista <code>books</code>, la ruta a la etiqueta es <code>title</code>. Este es el título de cada libro, que se mostrará como una opción en la lista desplegable.
    <b>Ruta hasta el valor</b>: en cada opción, la ruta al valor aquí es <code>isbn</code>. El objetivo es tener un valor único para cada elemento (si la etiqueta ya es diferente para cada elemento, puede colocar la ruta a la etiqueta en esta opción).

    <b>EJEMPLO AVANZADO</b>

    La fuente externa puede devolver datos con más niveles. En este caso, use <code>.</code> para descender nivel a nivel, por ejemplo:
    <pre>
    {
        "store": {
            "books": [
                {
                    "isbn": "0-553-21311-3",
                    "metadata": {
                        "author": "Herman Melville",
                        "category": "fiction",
                        "title": "Moby Dick"
                    },
                    "price": 8.99,
                },
                {
                    "isbn": "0-395-19395-8",
                    "metadata": {
                        "author": "J. R. R. Tolkien",
                        "category": "fiction",
                        "title": "The Lord of the Rings"
                    },
                    "price": 22.99,
                }
            ]
        }
    }
    </pre>
    <b>Ruta hasta las opciones</b>: <code>store.books</code>
    <b>Ruta hasta la etiqueta</b>: <code>metadata.title</code>
    <b>Ruta hasta el valor</b>: <code>isbn</code>
AdvancedSelect:
  noOptions: Sin opciones.
  sourceError: Ha ocurrido un error, vuelve a intentarlo.
  typeToSearch: Escribe para buscar.
  typeAtLeastNbChars: Escribe al menos {{minChars}} caracteres.
AdvancedToComparePage:
  back: vuelve a la lista
  title: '🔱 Comparación avanzada'
  description: Compare las respuestas de los diferentes encuestados (distinción de mayúsculas y minúsculas, error tipográfico, etc.). Sirve para evitar iteraciones y correcciones innecesarias
  empty: Los campos a comparar aparecerán aquí.
AudioPlayer:
  error:
    description: Error al subir el archivo
PDFViewer:
  error:
    description: Error al subir el PDF
IframeViewer:
  error:
    description: Iframe link incorrecto
PdfOcrViewer:
  previousPage: Página anterior
  nextPage: Página siguiente
  unzoom: Reducir zoom
  zoom: Aumentar zoom
  rotateLeft: Girar a la izquierda
  selectedValueNotFound: El valor seleccionado no se encuentra entre los valores disponibles
  forField: para el campo
  error:
    description: Error al subir el PDF
BlockForm:
  block: Bloque
  name: Nombre del bloque
  foldable: Plegable
  duplicable: Copia autorizada
  showIncrement: Mostrar el incremento
  iterativeBackground: Ajustar iteraciones
  maxRows: Altura máx.
  rowsRange: Número de iteraciones
  color: Color de fondo
  insertAfter: Insertar después de este bloque
  delete: Eliminar este bloque
BlockSortingRulesTemplate:
  addRule: 'Añadir una regla'
  empty: 'No hay reglas para este grupo.'
  uploadFailed: 'File upload failed : {{ message }}'
  error:
    duplicate: 'La regla ya contiene este campo.'
    mustBeInBlock: 'El campo debe pertenecer al grupo "{{ block }}".'
ContributeCloseButtonTemplate:
  back: Volver
  error: 'Error al liberar la tarea "{{ message }}".'
CertificationPage:
  published: Respuesta de referencia publicada.
ContributePage:
  backAction: Volver a
  answerError:
    description: Ha ocurrido un error durante el envío de tu tarea. Vuelve a intentarlo o contacta con nuestro servicio técnico.
  noTaskError:
    description: Has participado en todas las tareas de este proyecto.
  noCertificationError:
    description: Has respondido todas las preguntas de este certificación.
ContributeDonePage:
  title: Tarea guardada.
  quit: Salir
  newTask: Nueva tarea
ContributeFormErrorModal:
  title: Errores de validación
  description: Existen errores de validación en el formulario. Corrige los errores que encontrarás aquí debajo antes de volver a enviarlo.
  button: Corregir
  error: 'Error #{{ count }}'
  rowError: 'Error #{{ count }} (line #{{ row }})'
AdvancedSelectField:
  placeholder: 'Buscar y añadir'
DrawerContentBlocks:
  title: 'Crear un bloque'
  description: 'Añade un bloque a tu formulario'
DrawerContentBlocksSortingPage:
  empty: 'No tienes ningún grupo.'
  title: 'Reglas para la clasificación de grupos'
  description: 'Selecciona conjuntos de campos para comparar grupos.'
DrawerContentInfo:
  title: 'Instrucciones para la realización'
  description: 'Personaliza las instrucciones que verán los colaboradores para que estos puedan realizar el proyecto lo mejor posible. Añade un vídeo, una imagen o un enlace con el que puedan acceder a un tutorial... Podrán acceder haciendo clic en '
DrawerContentQuality:
  title: 'Opciones sobre calidad'
  description: ''
DrawerContentRespondants:
  title: ''
  description: ''
DrawerIterationOverloadPage:
  title: iteraciones adicionales
  description: Defina los casos para los que desea que la respuesta sea validada por más encuestados que el configurado. Si se cumplen las siguientes reglas, entonces se solicitará un encuestado más, aunque los primeros estén de acuerdo entre sí.
  newRule: Nueva regla
  empty: Sin reglas.
  newRuleLabel: Regla {{ count }}
DrawerContentStrategy:
  title: ' Gestión de las modalidades de tratamiento'
  description: 'Personaliza el proceso de tratamiento. El multiprocesamiento, por ejemplo, permite que cada tarea sea realizada por varios colaboradores y revisada automáticamente para garantizar la calidad del resultado'
DrawerContentNoCompare:
  title: ''
  description: ''
DrawerContentToComparePage:
  title: Campos que hay que comparar juntos
  description: Añade aquí los campos que hay que comparar juntos
  addRule: Añadir una regla
  empty: No existen reglas.
  duplicate: La regla ya contiene este campo.
  mustBeInSameBlock: Todos los campos de una regla deber formar parte del mismo grupo.
  invalidType: este tipo de campo no se puede agregar a la regla.
DrawerContentSettings:
  title: 'Configuración de tu formulario'
  description: 'Aquí puedes configurar las características de tu formulario.'
DrawerFormControls:
  publish: Publicar
  published: Publicado
  savePristine: Guardado
  saveDirty: Guardar
  missingRequired: 'Los campos siguientes son obligatorios para la publicación del formulario:'
  publishConfirm: ¿Quieres publicar tu formulario?
DrawerContentValidation:
  title: Reglas para la validación
  description: Validar la consistencia de las entradas realizadas mediante fórmulas de comparación.
  newRule: Nueva regla
  noRules: No existen reglas.
  newRuleName: 'Regla #{{ count }}'
ContributeFormTemplate:
  addBlock: Añadir
  clearBlock: Borrar todo
  submit: 'Responder'
  failedExecution: '{{ count }} regla(s) no han podido ser ejecutadas.'
ContributeAnswerDetailTemplate:
  taskError: Se ha producido un error
  task: 'Tarea #'
  project: Proyecto
  priority: Prioridad
  rate: Tasa
  quality: Calidad
  validate: Validar
DrawerHeaderTitlePage:
  unnamed: '(sin nombre)'
QualityNavTemplate:
  advancedToCompare: Comparación avanzada
  validation: Reglas de validación
  respondants: Personas que han respondido
  strategy: Estrategia de revisión
  noCompare: Campos fuera de la comparación
  toCompare: Campos que comparar
  blocksSorting: Clasificación de los grupos
  keyboardShortcuts: Reglas en la introducción de datos
  iterationOverload: Sobrecarga de iteración adicional
QualitySelectTemplate:
  respondants: Personas que han respondido
  strategy: Estrategia de revisión
EditFieldTemplate:
  createField: Crear un campo nuevo
EditDataTemplate:
  createData: Crear un nuevo campo de datos
EditPage:
  createButton: 'Nuevo campo'
  drawerTitle: '¡Crea tu primer campo!'
  drawerDescription: 'Arrastra y coloca o haz doble clic para añadir un campo'
DataPage:
  createButton: 'Campo de datos'
  drawerTitle: '¡Crea tu campo editable!'
  drawerDescription: “Arrastra y coloca o haz doble clic para añadir un campo. Añade campos editables desde la pestaña siguiente.”
Form:
  uniqueID: Identificador
  label: Etiqueta
  edit: Editar
  create: Crear
FormulaInput:
  prompt:
    LITERAL_DATE: "Ingrese una fecha válida en el formato (aaaa-mm-dd)"
    LITERAL_STRING: 'Introduce una cadena de caracteres:'
    LITERAL_NUMBER: 'Introduce una cadena de caracteres:'
FormulaField:
  invalidSyntax: La sintaxis es inválida
FormulaToken:
  sumOf: 'SUMA de'
  countOf: 'NÚMERO de'
  forEach: 'para todos los'
  forEachIter: 'A cada'
  forAll: 'Para toda la forma'
HideRuleFragment:
  enabled: Ocultar con formato condicional
  error:
    selfReference: Un campo no puede referirse a si mismo.
    subFieldReference: Un bloque no puede hacer referencia a un campo derivado.
    forbidden: No se puede hacer referencia aquí
InfoPage:
  title: Instrucciones para la realización
IterationOverloadRule:
  minMatch: Iteraciones para validar
  formulaPlaceholder: Comparación sencilla
  instructions: Agregue una regla de comparación simple con un campo y un valor fijo.
  deliveryAnswer: Elección de entrega
  errors:
    alreadyContained: Este campo ya está referenciado.
    wrongType: Este tipo de campo no es aceptado.
    isMulti: El campo seleccionado debe estar configurado en modo "Respuesta simple"
KeyboardShortcutsForm:
  key: 'tecla  "{{ key }}"'
  addShortcut: Añadir atajo
  value: Valor
MCQ:
  other: Otro
NoCompare:
  placeholder: Haz clic en un campo para añadirlo...
RangeField:
  min: Mín.
  max: Máx.
SettingsForm:
  averageDuration: Tiempo máximo
  minimumDuration: Tiempo mínimo
  keySkill: Habilidad clave
  subdivide: Repartir
  submitLabel: Botón validar
  allowError: Autorizar la validación de errores
  enterToValidate: Entrar para realizar el envío
ShortcutFragment:
  shortcut: atajo de teclado
PreviewPage:
  back: Volver
UploadInput:
  openDialog: Recorrer
  pending: Descargando...
  errors:
    belowMin: 'Mínimo permitido {{ tamaño }}mo.'
    aboveMax: 'Máximo permitido de {{ tamaño }}mo.'
QualityStrategyForm:
  answerMultiOptions:
    true: Enviar la mejor respuesta
    false: Enviar todas las respuestas
  answerProofReadingOptions:
    allAnswer: Enviar todas las respuestas
    lastAnswers: Enviar última respuesta de revisión
  samplePercent: Muestra inteligente
  matchingCount: Número de coincidencias
  iterationCount: Número de repeticiones máx.
  indeterminateMode: En caso de desacuerdo
  respondentPerTask: Número de personas que han respondido / Tarea
  proofreadingCount: Número de relecturas
  readerInstructions: Instrucciones para la relectura
  sendingAnswer: Enviar respuesta
  topOptions:
    panel: Panel
    multi: Procesamiento múltiple
    proofreading: Relectura
    simple: Introducción de datos simple
  isComplex:
    left: Introducción de datos simple
    right: Otras opciones
  sampleOptions:
    sample: Muestra
    multi: Multi
  undeterminateOptions:
    bestAnswer: Mejor respuesta
    manual: Manual
RegexRuleFragment:
  regex: expresión regular
  errorMessage: Mensaje de error
  regexHelp: Pruebe su expresión regular
  regexHelpLink: regex101.com
ValidationRule:
  executeWhenHidden: Ejecutar incluso si los campos están ocultos
  formulaPlaceholder: Fórmula...
  errorMessage: Mensaje de error
  errorMessagePlaceholder: El valor es incorrecto.
Copy: Copiar
WasCopied: ¡Copiado!

# Keys linked to fields typology
field:
  options:
    information: Información
    required: Obligatorio
    charsRange: Número de caracteres
    wordsRange: Número de palabras
    allowedDecimals: Enteros / Decimales
    integer: Entero
    decimals: Decimales
    optionalUnit: Unidad operacional
    valueRange: Valores
    longitudeRange: Tamaño de longitud
    latitudeRange: Tamaño de latitud
    values: Valores
    selectTypology: Tipo
    domains_accepted: Dominios aceptados
    domains_rejected: Dominios rechazados
    multi: Varias respuestas posibles
    allowOther: Es posible elegir “Otros”
    autoselect: Preseleccionar el primer valor
    activateLabelValue: Activar valores
    injectSeparatorValueLabel: Separador Valor
    separatorData: Separador de datos suministrado
    Errorseparator: Usa el separador
    labelValuePlaceholder: LABEL@@VALOR
    rib: RIB
    horizontal: Vista previa horizontal
    choices: Elección
    whitelist: Whitelist
    blacklist: Blacklist
    datetimeFormat: Formato de fecha y hora
    timeRange: Horas mín. y máx.
    dateRange: Fechas mín. y máx.
    onlyCountry: Solo país
    defaultFrance: Extensiones permitidas
    allowedExtentions: Extensions autorisées
    imagesOnly: archivo de imagen
    sizeRange: Tamaño del archivo (mo)
    choicesRange: Número de respuestas
    capitalized: Mayúscula al principio de una palabra
    injectChoices: Proporcionar opciones como datos
    injectSeparator: Separador
    options:
      date: Fecha
      time: Hora
      datetime: Fecha y hora
    remoteOptionsEnabled: Fuente externa
    remoteOptions:
      url: URL de flujos
      authorization: Autorización HTTP
      pathOptions: Ruta hasta las opciones
      pathLabel: Ruta hasta la etiqueta
      pathValue: Ruta hasta el valor
      addSupplierIDInHeaders: Añadir el ID al cabecera
      queryMode: Modo de búsqueda
      queryModeInstructions: Permite un modo de búsqueda dinámica en la fuente externa. El elemento {query} en la URL será reemplazado por el texto ingresado.
  text_short:
    label: Texto corto
  email:
    label: Correo electrónico
  coordinates_gps:
    label: Coordenadas GPS
  number:
    label: Campo numérico
  mcq:
    label: Cuestionario de opción múltiple / respuesta única
  phonenumber:
    label: Número de teléfono
  text:
    label: Texto
  url:
    label: URL
  select:
    label: Lista desplegable
  datetime:
    label: Fecha y hora
  address:
    label: Dirección
  file:
    label: Subir documento
  rib:
    label: IBAN/RIB

# Keys linked to fields data
data:
  options:
    content: Contenido
    link: Enlace
    information: Información
    fixedMode: Modo fijo
    perserveHeight: Conservar el alto
    perserveWidth: Conservar el ancho
  data_text:
    label: Texto
    numeric: 'Comparación numérica'
  data_numeric:
    label: 'Texto'
  data_embed:
    label: Visualizador
  data_url:
    label: Enlace formateado
  data_video:
    label: Vídeo
  data_audio:
    label: Audio
  data_image:
    label: Imagen
  data_iframe:
    label: Iframe

comparisonRules:
  options:
    case_sensitive: Distingue mayúsculas y minúsculas
    space_sensitive: Espacios sensibles
    special_char_sensitive: Caracteres especiales sensibles
    accent_sensitive: Sensible a los acentos
    distance: Diferencia
    deliveryAnswer: Respuesta a enviar
    timeunit: Unidad de tiempo
    options:
      1: 'Mejor recreación'
      2: 'Respuesta normalizada'
      3: 'Todas las iteraciones'
      4: 'Todas las iteraciones coinciden con las iteraciones mínimas requeridas'
      5: 'Todas las iteraciones coinciden al menos 2 veces'
      6: 'Promedio / Medio'
      7: 'Mejor colaborador'
      8: 'Mejor respuesta validando la(s) condición(es)'
      9: 'Vacío'
      second: Segundo
      minute: Minuto
      hour: Hora
      day: Día
      month: Mes
      year: Año

error:
  default:
    title: 'Se ha producido un error'
    body: 'Inténtelo de nuevo en unos instantes.'

# Keys linked to FieldError
FieldError:
  required: 'Este campo es obligatorio.'
  not_enough_chars: 'Número de caracteres insuficiente (min {{ value }}).'
  too_many_chars: 'Demasiados caracteres (max {{ value }}).'
  not_enough_words: 'Número de palabras insuficiente (min {{ value }}).'
  below_minimum: 'Valor inferior al mínimo (min {{ value }}).'
  above_maximum: 'Valor superior al máximo (Máx. {{ value }}).'
  too_many_words: 'Demasiadas palabras (max {{ value }}).'
  not_integer: 'El valor introducido {{ value }} no es un número entero.'
  not_number: 'El valor introducido {{ value }} no es un número.'
  denied_domains: 'El dominio introducido {{ value }} no está autorizado.'
  bad_format_email: 'Formato de correo electrónico inválido.'
  bad_format_phone: 'Formato de número de teléfono inválido.'
  time_below_minimum: 'La hora no puede ser inferior a {{ value }}.'
  time_above_maximum: 'La hora no puede ser superior a {{ value }}.'
  date_below_minimum: 'La fecha no puede ser inferior a {{ value }}.'
  date_above_maximum: 'La fecha no puede ser superior a {{ value }}.'
  bad_format_url: 'Esta URL no es válida.'
  invalid_address: 'La dirección es inválida.'
  invalid_syntax: 'La sintaxis es inválida.'
  regex_not_match: 'El valor debe respetar el formato {{ value }}'
  invalid_rib: 'Ibán no válido'
  invalid_date: 'Date no válido'

form:
  errors:
    title: Título del formulario
    errorChoicesSelectorMcq: Mala sintaxis en las elecciones del selector o qcm
    averageDuration: Configuración > Duración máxima
    minimumDuration: Configuración > Duración mínima
    respondentPerTask: Calidad > Número de personas que pueden responder por tarea
    missingBlockSortingRules: 'El grupo "{{block}}" no tiene una regla de clasificación'

popover:
  anchorEdit:
    title: Campos de respuesta
    text: 'Agregue los campos que desea ingresar: Texto, Fecha, Dirección, etc.'
    svg: undraw_approve
  anchorReload:
    title: Documentos para ingresar
    text: 'Añade los documentos e información que pondrás a disposición de los operadores para realizar sus entradas: pdf, imágenes, vídeos, texto, etc.'
    svg: undraw_collection
  anchorBlocks:
    title: Creación de grupos
    text: Agrupe ciertos campos para simplificar las entradas múltiples o repetitivas.
    svg: undraw_content
  anchorInfo:
    title: Información adicional
    text: Brinde toda la información útil a los operadores para ayudarlos durante la entrada.
    svg: undraw_reviewed
  anchorStrategy:
    title: Revisar la estrategia
    text: Determine los métodos de procesamiento de sus tareas para garantizar una calidad óptima (multiprocesamiento, revisión, muestreo, etc.)
    svg: undraw_Taking_notes
  anchorQuality:
    title: 'Opciones de calidad'
    text: 'Corregir las reglas de validación de formularios para obtener entradas de calidad (también permite gestionar las opciones de comparación en el caso de multiprocesamiento)'
    svg: undraw_update
  anchorSettings:
    title: Configuración general
    text: Establece aquí los tiempos mínimos y máximos permitidos, personaliza el botón de validación, etc.
    svg: undraw_preferences

toast:
  compare: Este campo está referenciado en los campos para comparar juntos/no comparar
  hideIf: Se hace referencia a este campo en la regla condicional oculta para el campo {{fieldName}}
  sorting: 'Se hace referencia a este campo en la regla de clasificación del grupo {{sortingName}}'
  rule: Este campo está referenciado en la regla de validación del formulario.
regex:
  enabled: Validación por expresión regular
